import { Attributes } from "../model/attributes";

export class Create {
    constructor(
        public userName: string,
        public email: string,
        public admin: boolean,
        public attributes: Attributes
    ){
    }
}
